import toast from "react-hot-toast";
import { type NotificationType, Notification } from "../components/Notification/Notification";

type NotificationOptions = {
  title: string;
  description: string;
  duration?: number;
};

const DEFAULT_DURATION = 3000;

const buildShowNotification =
  (type: NotificationType) =>
  ({ title, description, duration = DEFAULT_DURATION }: NotificationOptions) => {
    return toast.custom(
      (toastProps) => <Notification {...toastProps} type={type} title={title} description={description} />,
      {
        duration,
      },
    );
  };

export const notification = {
  success: buildShowNotification("success"),
  danger: buildShowNotification("danger"),
  info: buildShowNotification("info"),
};
